import { mapGetters } from 'vuex';
import { loadCmAds } from '@/common/utilities/nojq/_load.ojolink.js';
import { getStorage } from '../../utilities/nojq/_localstorage.js';
import { ids } from '@/common/utilities/nojq/_adstrackdata.js';
const loadedAds = [];
function elementIsVisibleInViewport(el, partiallyVisible = false) {
    if (!el || !el.getBoundingClientRect) {
        return false;
    }
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
        ? (top > -125 && left > -125) && bottom < (innerHeight + 125) && right < (innerWidth + 125)
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
}
function loadAds(node) {
    if (node.__vue__ && typeof node.__vue__.load === 'function') {
        node.__vue__.load();
        return;
    }
}
function lazyloadAds(ads) {
    if (window.IntersectionObserver) {
        if (!window.observerAds) {
            const options = {
                rootMargin: '0% 0% 0% 0%',
                threshold: 0,
            };
            window.observerAds = new IntersectionObserver(function (entries) {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }
                    loadAds(entry.target);
                    window.observerAds.unobserve(entry.target);
                });
            }, options);
        }
        window.observerAds.observe(ads);
    } else {
        loadAds(ads);
    }
}


export default {
    name: 'mvtAds',
    inject: ['$eventBus'],
    props: {
        lazyload: {
            type: Boolean,
            default: true,
        },
        removable: {
            type: Boolean,
            default: false,
        },
        options: {
            type: Object,
            default: function () {
                return null;
            },
        },
        sendGaEvent: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loaded: false,
            timer: null,
            refreshAdsTimer: null,
            initialed: false,
            removed: false,
            lastLoadTime: null,
        };
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('msp', ['msp', 'getListings']),

        getId() {
            let id = '';
            if (!this.options) {
                return id;
            }
            switch (this.options.type) {
                case 'sticky':
                    id = this.glb.rentals ? ids.sticky.rentals[this.options.index] : ids.sticky.inactive[this.options.index];
                    break;
                case 'badge':
                    id = ids.badge[this.options.name];
                    break;
                case 'photo':
                    id = ids.photo.dpp[this.options.index];
                    break;
                case 'origin':
                    id = this.glb.rentals ? ids.origin.rentals[this.options.index] : this.options.isActive ? ids.origin.active[this.options.index] : ids.origin.inactive[this.options.index];
                    break;
                case 'dpp':
                    id = this.glb.rentals ? ids.dpp.rentals[this.options.index] : this.options.isActive ? ids.dpp.active[this.options.index] : ids.dpp.inactive[this.options.index];
                    break;
                case 'search':
                    // return ids.msp.desktop[this.options.index];
                    id = this.glb.rentals ? ids.msp.rentals[this.options.index] : this.glb.isPhone ? ids.msp.mobile[this.options.index] : ids.msp.desktop[this.options.index];
                    break;
                case 'banner':
                    id = ids.msp.banner[this.options.index];
                    break;
            }
            id = id.split('_')[0];
            return id;
        },
        cmWrapper() {
            return window.cmWrapper;
        },
    },
    methods: {
        remove() {
            if (!this.removable) {
                return;
            }
            if (this.cmWrapper && this.cmWrapper.ads && this.cmWrapper.ads.destroyUnits) {
                this.cmWrapper.ads.destroyUnits([this.getId]);
            }
            this.removed = true;
        },
        refresh(force) {
            if (!elementIsVisibleInViewport(this.$el, true)) {
                if (this.glb.log) {
                    console.log('disable refresh ads not in view:' + this.getId);
                }
                return;
            }
            if (!force && this.lastLoadTime > 0 && Date.now() - this.lastLoadTime < 45000) {
                if (this.glb.log) {
                    console.log('disable refresh ads in 45s :' + this.getId);
                }
                return;
            }
            if (!document.hidden) {
                if (this.loaded) {
                    this.loaded = false;
                    if (this.lazyload) {
                        lazyloadAds(this.$el);
                    } else {
                        this.load();
                    }
                }
            } else {
                if (this.glb.log) {
                    console.log('disable refresh ads in inactive tab:' + this.getId);
                }
            }
        },
        load() {
            if (!this.initialed) {
                this.initialed = true;
                setTimeout(() => {
                    let event = 'ontouchstart' in window ? 'touchstart' : 'click';
                    $(document).on(`${event}.${this.vnumber}`, () => {
                        this.refreshAdsTimer && clearTimeout(this.refreshAdsTimer);
                        this.refreshAdsTimer = setTimeout(() => {
                            this.refresh();
                        }, 3000);
                    });

                    $(document).on('dom.scroll.' + this.vnumber, () => {
                        this.refreshAdsTimer && clearTimeout(this.refreshAdsTimer);
                        this.refreshAdsTimer = setTimeout(() => {
                            this.refresh();
                        }, 3000);
                    });
                }, 3000);
            }
            if (this.loaded) {
                return;
            }
            this.loaded = true;
            var that = this;
            if (this.glb.log) {
                console.log('load ads:' + this.getId);
            }
            this.lastLoadTime = Date.now();
            const cmAdsTreatment = this.glb.pageType === 'vmapsearch'
                ? this.glb.splits['movoto-cm-ads-wrapper-variant-CW-4620']
                : undefined;
            loadCmAds(cmAdsTreatment).then((cmWrapper) => {
                // console.log('load ads:' + this.vnumber);
                if (this.cmWrapper && this.cmWrapper.ads && this.cmWrapper.ads.refreshUnits && loadedAds.indexOf(this.getId) > -1) {
                    var requestUnitsData = that.getDataForAdUnits();
                    this.cmWrapper.ads.requestUnits(Object.entries(requestUnitsData));
                    this.cmWrapper.ads.refreshUnits([this.getId]);
                    // console.log('refresh ads' + this.options.index);
                    return;
                }
                if (this.cmWrapper && this.cmWrapper.que) {
                    this.cmWrapper.que.push(() => {
                        if (this.sendGaEvent) {
                            this.$eventBus.$emit('ga', { en: 'impression', ec: 'ads_script', el: this.getId });
                            var target = document.getElementById(this.getId);
                            if (!target) {
                                return;
                            }
                            var observer = new MutationObserver((mutations) => {
                                mutations.forEach((mutation) => {
                                    if (mutation.addedNodes.length > 0) {
                                        //when there is iframe inside
                                        if (mutation.addedNodes[0] && mutation.addedNodes[0].id === 'google_ads_iframe_/14503085/CordlessMedia_Movoto.com_ATF_PropertyBadge_0__container__') {
                                            this.$eventBus.$emit('ga', { en: 'impression', ec: 'ads_iframe', el: this.getId });
                                        }
                                        observer.disconnect();
                                    }
                                });
                            });
                            observer.observe(target, { childList: true });
                            setTimeout(() => {
                                observer && observer.disconnect();
                            }, 10000);
                        }
                        var requestUnitsData = that.getDataForAdUnits();
                        this.cmWrapper.ads.defineUnit(this.getId);
                        this.cmWrapper.ads.requestUnits(Object.entries(requestUnitsData));
                        loadedAds.push(this.getId);
                    });
                }
            });
        },
        getDataForAdUnits() {
            var mspData = {};
            if (this.msp) {
                if (['ADDRESS', 'STREET'].indexOf(this.msp.searchType) > -1) {
                    mspData.address = this.msp.searchInput;
                }
                if (this.msp) {
                    let geo = this.msp && this.getListings && this.getListings.length > 0 ? this.getListings[0].geo : this.msp.geo;
                    if (geo) {
                        if (geo.city) {
                            mspData.city = geo.city;
                        }
                        if (geo.state) {
                            mspData.state = geo.state;
                        }
                        if (geo.zipcode) {
                            mspData.zip = geo.zipcode;
                        }
                    }
                }

                if (this.msp.filter) {
                    if (+this.msp.filter.minPrice !== 0) {
                        mspData.Listing_Price = this.msp.filter.minPrice;
                    } else if (+this.msp.filter.maxPrice !== 0) {
                        mspData.Listing_Price = this.msp.filter.maxPrice;
                    }
                }
                mspData['prebid_viewable'] = '11806:off';

                if (this.getSplit('movoto-banner-ads-msp-cw-183')) {
                    const currentView = ['list-view', 'grid-view'].indexOf(getStorage('currentViewStatus'));
                    mspData['view'] = currentView > -1 ? 'list' : 'map';
                }
            }
            return mspData;
        },
    },
    mounted() {
        if (this.glb.enableThirdPart === false) {
            return;
        }
        if (!this.$el || !this.$el.innerHTML) {
            return;
        }
        if (this.lazyload) {
            lazyloadAds(this.$el);
        } else {
            this.load();
        }
        $(document).on('ads.update.' + this.vnumber, () => {
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(() => {
                this.refresh(true);
            }, 500);
        });
        $(document).on('dom.resize.' + this.vnumber, (e, isWidthChange) => {
            if (isWidthChange) {
                this.refresh();
            }
        });
    },
    beforeUnmount() {
        let event = 'ontouchstart' in window ? 'touchstart' : 'click';
        $(document).off(`${event}.${this.vnumber}`);
        $(document).off('ads.update.' + this.vnumber);
        $(document).off('dom.resize.' + this.vnumber);
        $(document).off('dom.scroll.' + this.vnumber);
        // loadCmAds().then((this.cmWrapper) => {
        //     this.cmWrapper.ads.destroyUnits([this.getId]);
        // });
        // console.log('destory ads:' + this.vnumber);
    },
};
